import { createBrowserRouter } from 'react-router-dom';
import DevLayout from '@app/components/DevLayout';
import FunctionalityGuard from '@app/components/guards/FunctionalityGuard';
import { FINANCING_OPTIONS } from '@app/configs/financing';
import { ROUTES } from '@app/configs/routes';
import BorrowerStart from '@pages/borrowerStart/BorrowerStart';
import DemoCalculator from '@pages/demoCalculator/DemoCalculator';
import DevLogin from '@pages/devLogin/DevLogin';
import Home from '@pages/home/Home';
import Invest from '@pages/invest/Invest';
import Investment from '@pages/investmentDetails/InvestmentDetails';
import InvestorStart from '@pages/investorStart/InvestorStart';
import LoanApplicationPage from '@pages/loanApplication/LoanApplication';
import LoanDetails from '@pages/loanDetails/LoanDetails';
import SolvencyDeclarationPage from '@pages/solvencyDeclaration/SolvencyDeclaration';
const createDevRouter = ({ basename = '/', isStandalone = false, } = {}) => createBrowserRouter([
    {
        element: <DevLayout />,
        children: [
            {
                path: ROUTES.home,
                element: (<FunctionalityGuard>
                                <Home />
                            </FunctionalityGuard>),
            },
            {
                path: ROUTES.borrowerStart,
                element: (<FunctionalityGuard requiredFunctionality={FINANCING_OPTIONS.borrower_read}>
                                <BorrowerStart />
                            </FunctionalityGuard>),
            },
            {
                path: ROUTES.loanDetails,
                element: (<FunctionalityGuard requiredFunctionality={FINANCING_OPTIONS.borrower_read}>
                                <LoanDetails />
                            </FunctionalityGuard>),
            },
            {
                path: ROUTES.investorStart,
                element: (<FunctionalityGuard requiredFunctionality={FINANCING_OPTIONS.investor_read}>
                                <InvestorStart />
                            </FunctionalityGuard>),
            },
            {
                path: ROUTES.solvencyDeclaration,
                element: (<FunctionalityGuard requiredFunctionality={FINANCING_OPTIONS.solvency_declaration}>
                                <SolvencyDeclarationPage />
                            </FunctionalityGuard>),
            },
            {
                path: ROUTES.solvencyDeclarationWebview,
                element: <SolvencyDeclarationPage isMobile/>,
            },
            {
                path: ROUTES.loanApplication,
                element: (<FunctionalityGuard requiredFunctionality={FINANCING_OPTIONS.loan_application}>
                                <LoanApplicationPage />
                            </FunctionalityGuard>),
            },
            {
                path: ROUTES.investmentDetails,
                element: <Investment isStandalone/>,
            },
            {
                path: ROUTES.invest,
                element: <Invest isStandalone/>,
            },
            process.env.NODE_ENV === 'development' && isStandalone
                ? {
                    path: ROUTES.login,
                    element: <DevLogin />,
                }
                : {},
        ],
    },
    {
        path: ROUTES.demoCalculator,
        element: <DemoCalculator />,
    },
], { basename });
export default createDevRouter;
